import { createContext, useContext, useEffect, useState } from 'react';
import { MessageBox, NewMessage } from '../../../components/widgets/MessagesWidget';
import { useGetMessages, postMarkMessageRead } from '../../api/functions/messages';

const MessagesContext = createContext(); 

export const MessagesProvider = ({children}) => {
    const [show, setShow] = useState(false); 
    const [messages, setMessages] = useState([]); 
    const [activeMessage, setActiveMessage] = useState(null); 
    const { data, mutate } = useGetMessages({}); 
    const [showNewMessageForm, setShowNewMessageForm] = useState(false); 

    console.log("messages data: ", data);

    const showMessageBox = () => {
        setShow(true); 
    }
    const hideMessageBox = () => {
        setShow(false); 
    }
    const openMessage = (message, showBox=true) => {
        console.log("OPENING MESSAGE: ", message); 
        if (!message) return;

        if(showBox) showMessageBox(); 

        const conversationId = message?.message?.conversation_id ?? message?.conversation_id;
        const isAlreadyRead = Number(message?.message?.read ?? message?.read) === 1;

        const nextActiveMessage = !isAlreadyRead && message?.message
            ? {
                ...message,
                recipient: {
                    ...message.recipient, 
                    inbox_read: 1
                }
            }
            : message;

        setActiveMessage(nextActiveMessage);

        if (!conversationId) {
            return;
        }

        if (!isAlreadyRead) {
            setMessages((prev) => {
                if (!Array.isArray(prev)) return prev;
                return prev.map((item) => {
                    const itemConversationId = item?.message?.conversation_id ?? item?.conversation_id;
                    if (itemConversationId !== conversationId) return item;

                    if (item?.message) {
                        return {
                            ...item,
                            recipient: {
                                ...item.recipient, 
                                inbox_read: 1
                            }
                        };
                    }

                    return item;
                });
            });

            mutate((current) => {
                if (!current || !current.body) return current;

                const updatedResponse = Array.isArray(current.body.response)
                    ? current.body.response.map((item) => {
                        const itemConversationId = item?.message?.conversation_id ?? item?.conversation_id;
                        if (itemConversationId !== conversationId) return item;

                        if (item?.message) {
                            return {
                                ...item,
                                recipient: {
                                    ...item.recipient,
                                    inbox_read: 1
                                }
                            };
                        }

                        return item;
                    })
                    : current.body.response;

                const unreadCount = current.body.getUnreadMessageCount ?? 0;

                return {
                    ...current,
                    body: {
                        ...current.body,
                        response: updatedResponse,
                        getUnreadMessageCount: unreadCount > 0 ? unreadCount - 1 : 0,
                    },
                };
            }, false);
        }

        const formData = new FormData();
        formData.append("message_id", conversationId);
        formData.append("is_read", 1);

        postMarkMessageRead(formData).catch((error) => {
            console.error("Failed to mark message as read", error);
        });
    }
    const closeMessage = () => {
        setActiveMessage(null); 
    }
    const openNewMessage = (user_data) => {
        setShowNewMessageForm(user_data); 
    }   
    const closeNewMessage = (message) => {
        setShowNewMessageForm(false);  
        if(message) openMessage(message); 
        
    }
    const updateMessages = () => {
        mutate(); 
    }

    useEffect(() => {
        if (data && data.body && data.body.response) {
            setMessages(data.body.response); 
        }
    })

    return (
        <MessagesContext.Provider value={{show, showMessageBox, hideMessageBox, openMessage, closeMessage, openNewMessage, closeNewMessage, messages, activeMessage, setActiveMessage, showNewMessageForm}}>
            {children}
            <MessageBox/>
            <NewMessage />
        </MessagesContext.Provider>
    )

}; 

export const useMessages = () => {
    const { show, showMessageBox, hideMessageBox, openMessage, closeMessage, messages, activeMessage, setActiveMessage, openNewMessage, closeNewMessage, showNewMessageForm } = useContext(MessagesContext);
    return { show, showMessageBox, hideMessageBox, openMessage, closeMessage, messages, activeMessage, setActiveMessage, openNewMessage, closeNewMessage, showNewMessageForm }; 
}
